var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{directives:[{name:"resize",rawName:"v-resize",value:(_vm.onResize),expression:"onResize"}],ref:"container"},[_c('AppBar',{ref:"appBar"}),_c('div',[_c('NavDrawer')],1),_c('v-main',{style:({ height: `${_vm.height}px` })},[_c('router-view'),_c('Errors')],1),_c('Footer',{ref:"footer"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }